if (!customElements.get("variant-picker")) {
   class t extends HTMLElement {
      constructor() {
         super(), Shopify.designMode ? setTimeout((() => this.init()), 200) : this.init()
      }
      init() {
         this.selectors = {
            error: ".m-product-form-message",
            variantIdInput: '[name="id"]',
            pickerFields: ["[data-picker-field]"],
            optionNodes: [".m-product-option--node"],
            productSku: "[data-variant-sku]",
            productAvailability: "[data-availability]",
            shareUrlInput: "[data-share-url]",
            stockCountdown: ".prod__stock-countdown",
            productWrapper: ".m-main-product--wrapper"
         }, this.productWrapper = this.closest(this.selectors.productWrapper), this.productForm = this.productWrapper.querySelector("product-form"), this.domNodes = queryDomNodes(this.selectors, this.productWrapper);
         const t = window._themeProducts || {},
            {
               productId: e,
               sectionId: a,
               productUrl: i,
               hasOnlyDefaultVariant: r,
               showFeaturedMedia: s
            } = this.dataset;
         this.productId = e, this.sectionId = a, this.productUrl = i, this.hasOnlyDefaultVariant = "true" === r, this.showFeaturedMedia = "true" === s, this.variantData = this.getVariantData(), this.productData = Object.assign(this.getProductJson(), t[e]);
         // Storefront-only buffer: make Minimog's native variant-picker disable
         // buttons for tracked, non-backorder variants at the chosen threshold.
         const buffer = Number(window.MinimogSettings?.palmbee_soldout_threshold ?? 2);
         const applyBuffer = (variants) => {
            if (!Array.isArray(variants)) return;
            variants.forEach((variant) => {
               if (variant.inventory_management === "shopify" && variant.inventory_policy === "deny" && Number.isFinite(Number(variant.inventory_quantity)) && variant.inventory_quantity !== undefined && Number(variant.inventory_quantity) <= buffer) {
                  variant.available = false;
               }
            });
         };
         applyBuffer(this.productData.variants);
         applyBuffer(this.variantData);
         // Read exact variant stock statuses exported by Liquid. Shopify's
         // product | json strips inventory policy/quantity, and relying on
         // that JSON alone causes Minimog to re-enable Sold Out buttons.
         const stockData = this.querySelector('#palmbeeStockVariants[type="application/json"]');
         if (stockData) {
            try {
               const stockMap = new Map(JSON.parse(stockData.textContent).map((variant) => [Number(variant.id), variant]));
               for (const variants of [this.productData.variants, this.variantData]) {
                  if (!Array.isArray(variants)) continue;
                  variants.forEach((variant) => {
                     const stock = stockMap.get(Number(variant.id));
                     if (stock) Object.assign(variant, stock);
                  });
               }
            } catch (error) {
               console.warn('Palm Bee inventory buffer data could not be read', error);
            }
         }
         this.handleQueryString(), this.handleVariantGroupImages(), this.selectInitialVariant(), this.setupEventListeners(), this.initOptionSwatches()
      }
      handleQueryString() {
         const t = window.location.search.includes("?variant=");
         this.selectedVariantDefault = "true" === this.dataset.disableSelectedVariantDefault && this.productData && this.productData.variants.length > 1 && !t, this.selectedVariantDefault && this.disableSelectedVariantDefault()
      }
      handleVariantGroupImages() {
         this.enableVariantGroupImages = "true" === this.dataset.enableVariantGroupImages, this.enableVariantGroupImages && (this.variantGroupImages = this.getVariantGroupImageData())
      }
      selectInitialVariant() {
         this.selectedVariant = this.productWrapper.querySelector(this.selectors.variantIdInput);
         const t = Number(this.selectedVariant.value);
         this.currentVariant = this.productData.variants.find((e => e.id === t)), this.productData.current_variant_id = this.currentVariant && this.currentVariant.id, this.productData.initialVariant = this.currentVariant, this.currentVariant && (this.getDataImageVariant(this.currentVariant.id), this.hideSoldOutAndUnavailableOptions(), this.updateButton(!this.currentVariant.available, this.currentVariant.available ? "" : window.MinimogStrings.soldOut), this.syncStockQuantityLimit())
      }
      setupEventListeners() {
         const t = () => this.getMediaGallery();
         t(), document.addEventListener("matchMobile", t), document.addEventListener("unmatchMobile", t), this.addEventListener("change", this.onVariantChange)
      }
      async getMediaGallery() {
         await this.waitForMediaGallery(), this.setupMediaGallery()
      }
      waitForMediaGallery() {
         return new Promise((t => {
            const e = () => {
               this.mediaGallery = this.productWrapper.querySelector("media-gallery"), this.mediaGalleryMobile = this.productWrapper.querySelector("media-gallery-mobile"), this.mediaGallery || this.mediaGalleryMobile ? t() : setTimeout(e, 100)
            };
            e()
         }))
      }
      setupMediaGallery() {
         const t = MinimogTheme.config.mqlMobile,
            e = t && this.mediaGalleryMobile || this.mediaGallery;
         this.media = e, t || "slider" === e.mediaMode ? (this.slides = e.slider && e.slider.slides, this.slidesNav = e.navSlider && e.navSlider.slides) : this.mediaItems = e.querySelectorAll(".m-product-media--item"), this.layout = t ? void 0 : e.layout, (!this.showFeaturedMedia || this.enableVariantGroupImages && this.variantGroupImages.enable) && this.updateMedia()
      }
      disableSelectedVariantDefault() {
         this.querySelectorAll('input[type="radio"]').forEach((t => {
            t.checked = !1
         })), this.querySelectorAll("[data-picker-field='radio']").forEach((t => {
            t.setAttribute("data-selected-value", "")
         })), this.querySelectorAll("[data-picker-field='select']").forEach((t => {
            const e = t.querySelector("select");
            e && (e.value = ""), t.setAttribute("data-selected-value", "")
         })), this.querySelectorAll(".option-label--selected").forEach((t => {
            t.textContent = ""
         }));
         const t = this.productForm && this.productForm.querySelector("[name='id']");
         t && !this.hasOnlyDefaultVariant && (t.value = "")
      }
      setProductAsUnavailable() {
         this.updateButton(!0), this.setUnavailable()
      }
      updateProductDetailsForVariant() {
         this.getDataImageVariant(this.currentVariant.id), this.updateMedia(), this.updateBrowserHistory(), this.updateVariantInput(), this.updateProductMeta(), this.updatePrice();
         const t = !this.currentVariant.available,
            e = t ? window.MinimogStrings.soldOut : "";
         this.updateButton(t, e), this.hideSoldOutAndUnavailableOptions(), this.syncStockQuantityLimit()
      }
      onVariantChange() {
         this.getSelectedOptions(), this.getSelectedVariant(), this.updatePickupAvailability(), this.removeErrorMessage(), this.currentVariant ? (this.updateProductDetailsForVariant(), window.MinimogEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this)) : this.setProductAsUnavailable()
      }
      syncStockQuantityLimit() {
         const input = this.productWrapper?.querySelector('.m-quantity__input');
         const variant = this.currentVariant;
         if (!input || !variant) return;
         let maximum = variant.quantity_rule?.max ?? null;
         if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
            const buffer = Number(window.MinimogSettings?.palmbee_soldout_threshold ?? 2);
            const remaining = Math.max(0, Number(variant.inventory_quantity) - buffer);
            maximum = maximum == null ? remaining : Math.min(maximum, remaining);
         }
         if (maximum == null) {
            input.removeAttribute('max');
            input.removeAttribute('data-max');
         } else {
            input.max = String(maximum);
            input.dataset.max = String(maximum);
            if (maximum >= Number(input.min || 1) && Number(input.value) > maximum) {
               input.value = String(maximum);
            }
         }
      }
      getDataImageVariant(t) {
         if (!this.variantGroupImages || !this.variantGroupImages.enable) return;
         const e = this.variantGroupImages.mapping.find((e => Number(e.id) === t));
         e && (this.currentVariantMedia = e.media)
      }
      getProductJson() {
         try {
            const t = this.productWrapper.querySelector("#productData[type='application/json']");
            if (!t) throw new Error("Fallback product data element not found.");
            return JSON.parse(t.textContent)
         } catch (t) {}
      }
      getSelectedVariant() {
         let t, e = [...this.options];
         for (let a = 0; a < this.options.length && (t = getVariantFromOptionArray(this.productData, e), !t && 0 !== e.length); a++) e.pop();
         t && (this.options = [...t.options], this.updateSelectedOptions()), this.currentVariant = t
      }
      getSelectedOptions() {
         const t = Array.from(this.querySelectorAll("[data-picker-field]"));
         this.options = t.map((t => {
            if ("radio" === t.dataset.pickerField) {
               const e = t.querySelector("input:checked");
               return e ? e.value : void 0
            }
            if (t.querySelector("select")) return t.querySelector("select").value
         })).filter((t => void 0 !== t))
      }
      updateSelectedOptions() {
         this.domNodes.pickerFields.forEach(((t, e) => {
            if (t.dataset.selectedValue !== this.options[e]) {
               const a = t.querySelector(`input[value="${this.options[e].replace(/["\\]/g,"\\$&")}"]`);
               a && (a.checked = !0, t.updateSelectedValue())
            }
         }))
      }
      removeLoading(t) {
         t && (t.removeAttribute("data-media-loading"), t.firstElementChild.style.opacity = 1)
      }
      handleImageZoom(t, e) {
         const a = t.map((t => {
            const e = t.dataset.mediaType;
            if ("image" === e) {
               const e = t.querySelector(".m-product-media").dataset;
               return {
                  src: e.mediaSrc,
                  width: parseInt(e.mediaWidth),
                  height: parseInt(e.mediaHeight),
                  alt: e.mediaAlt,
                  id: t.dataset.index
               }
            }
            return {
               html: `<div class="pswp__${e}">${t.innerHTML}</div>`,
               type: e,
               id: t.dataset.index
            }
         }));
         e && e.lightbox && (e.lightbox.destroy(), e.handlePhotoswipe(a), e.initPhotoswipe())
      }
      updateMedia() {
         if (!this.currentVariant) return;
         let t = [],
            e = [];
         const a = (t, e, a = !1, i = !1) => {
               let r = [];
               return t.forEach(((t, a) => {
                  const i = e.find((e => e.querySelector("[data-media-id]").dataset.mediaId === t));
                  i && (i.dataset.index = a, i.dataset.swiperSlideIndex = a, r.push(i))
               })), e.forEach((e => {
                  const a = e.querySelector("[data-media-id]").dataset.mediaId;
                  t.includes(a) || r.includes(e) || (e.dataset.index = r.length, e.dataset.swiperSlideIndex = r.length, r.push(e))
               })), i && r.forEach((t => {
                  a ? t.classList.toggle("swiper-slide-thumb-active", "0" === t.dataset.swiperSlideIndex) : t.classList.toggle("swiper-slide-active", "0" === t.dataset.swiperSlideIndex)
               })), r
            },
            i = (t, e) => {
               t.forEach((t => {
                  const a = t.querySelector("[data-media-id]").dataset.mediaId,
                     i = this.currentVariantMedia && this.currentVariantMedia.length > 0 && this.currentVariantMedia.includes(a),
                     r = !t.classList.contains("media-type-image");
                  (i || r || !this.currentVariantMedia || 0 === this.currentVariantMedia.length) && e.push(t)
               }))
            };
         if (this.variantGroupImages && this.variantGroupImages.enable)
            if ("slider" === this.media.mediaMode && this.slides) {
               i(this.slides, t);
               const r = a(this.currentVariantMedia, t, !1, !0);
               if (this.media.slider.removeAllSlides(), this.media.slider.appendSlide(r), this.media.slider.slideToLoop("layout-7" === this.layout ? 1 : 0), this.media.handleSlideChange(), this.slidesNav) {
                  i(this.slidesNav, e);
                  const t = a(this.currentVariantMedia, e, !0, !0);
                  this.media.navSlider && this.media.navSlider.removeAllSlides(), this.media.navSlider && this.media.navSlider.appendSlide(t), this.media.navSlider && this.media.navSlider.slideToLoop(0)
               }
            } else {
               const e = this.media.querySelector(".m-product-media--list");
               if (!e) return;
               i(this.mediaItems, t);
               const r = a(this.currentVariantMedia, t);
               e.innerHTML = "", r.forEach(((t, a) => {
                  "layout-2" === this.layout && (t.classList.remove("m-col-span-2"), a % 3 == 0 && t.classList.add("m-col-span-2")), e.append(t)
               }))
            }
         else {
            let t = 0;
            this.media && "mediaSize" in this.media.dataset && (t = parseInt(this.media.dataset.mediaSize, 10)), t > 0 && this.media.setActiveMedia(this.currentVariant)
         }
         this.removeLoading(this.media), this.handleImageZoom(t, this.media)
      }
      updateBrowserHistory() {
         this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.productUrl}?variant=${this.currentVariant.id}`)
      }
      updateVariantInput() {
         document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`).forEach((t => {
            const e = t.querySelector(this.selectors.variantIdInput);
            e && (e.value = this.currentVariant.id, e.dispatchEvent(new Event("input", {
               bubbles: !0
            })))
         }))
      }
      updatePickupAvailability() {
         const t = this.productWrapper.querySelector("pickup-availability");
         t && this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : t && (t.removeAttribute("available"), t.innerHTML = "")
      }
      removeErrorMessage() {
         const t = this.closest("section");
         if (!t) return;
         const e = t.querySelector("product-form");
         e && e.handleErrorMessage()
      }
      updatePrice() {
         const t = "m-price--on-sale",
            e = "m-price--sold-out",
            a = this.productWrapper.querySelector(".main-product__block-price");
         if (!a) return;
         const i = window.MinimogSettings.money_format,
            {
               priceWrapper: r,
               salePrice: s,
               unitPrice: n,
               compareAtPrice: o,
               saleBadge: d,
               saleAmount: l,
               unitPriceWrapper: c
            } = queryDomNodes({
               priceWrapper: ".m-price",
               salePrice: ".m-price-item--sale",
               compareAtPrice: [".m-price-item--regular"],
               unitPrice: ".m-price__unit",
               unitPriceWrapper: ".m-price__unit-wrapper",
               saleBadge: ".m-price__badge-sale",
               saleAmount: "[data-saved-price]"
            }, a),
            {
               compare_at_price: u,
               price: h,
               unit_price_measurement: p,
               available: m
            } = this.currentVariant,
            v = r.dataset.saleBadgeType,
            g = u && u > h,
            y = !m;
         if (r.classList.toggle(t, g), r.classList.toggle(e, y), r.classList.remove("m:visibility-hidden"), s && (s.innerHTML = formatMoney(h, i)), o && o.forEach((t => {
               const e = g ? u : h;
               t.innerHTML = formatMoney(e, i)
            })), d && g && "text" !== v) {
            let t;
            if ("fixed_amount" === v) t = formatMoney(u - h, i);
            else {
               t = Math.round(100 * (u - h) / u) + "%"
            }
            l && (l.innerHTML = t)
         }
         if (p && n) {
            c.classList.remove("m:hidden");
            const t = `<span>${formatMoney(this.currentVariant.unit_price,i)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
            n.innerHTML = t
         } else c.classList.add("m:hidden")
      }
      _getBaseUnit = () => {
         const {
            reference_value: t,
            reference_unit: e
         } = this.currentVariant.unit_price_measurement;
         return 1 === t ? e : `${t}${e}`
      };
      updateButton(t = !0, e) {
         const a = document.querySelectorAll(`.product-form-${this.sectionId}`);
         a.length && a.forEach((a => {
            const i = a.querySelector('[name="add"]'),
               r = a.querySelector(".m-product-dynamic-checkout"),
               s = i.querySelector(".m-add-to-cart--text");
            if (!i) return;
            t ? (i.setAttribute("disabled", "disabled"), i.classList.add("disabled"), r && r.classList.add("disabled"), e && (s.textContent = e)) : (i.removeAttribute("disabled"), i.classList.remove("disabled"), r && r.classList.remove("disabled"), s.textContent = window.MinimogStrings.addToCart)
         }))
      }
      updateProductMeta() {
         const {
            available: t,
            sku: e
         } = this.currentVariant, {
            inStock: a,
            outOfStock: i
         } = window.MinimogStrings, r = this.productWrapper.querySelector(this.selectors.productAvailability), s = this.productWrapper.querySelector(this.selectors.productSku);
         s && (s.textContent = e || "N/A"), (() => {
            if (r) {
               const e = t ? "remove" : "add";
               r.textContent = t ? a : i, r.classList[e]("m-product-availability--outofstock")
            }
         })()
      }
      setUnavailable() {
         const t = document.getElementById(`product-form-${this.sectionId}`),
            e = t ? t.querySelector('[name="add"]') : null,
            a = e ? e.querySelector(".m-add-to-cart--text") : null,
            i = this.productWrapper.querySelector(".m-price");
         e && (a && (a.textContent = window.MinimogStrings.unavailable), i && i.classList.add("m:visibility-hidden"))
      }
      hideSoldOutAndUnavailableOptions() {
         const t = "m-product-option--node__soldout",
            e = "m-product-option--node__unavailable",
            {
               optionNodes: a
            } = this.domNodes,
            {
               variants: i,
               options: r
            } = this.productData;
         a.forEach((a => {
            const {
               optionPosition: s,
               value: n
            } = a.dataset, o = Number(s), d = "OPTION" === a.tagName;
            let l = [];
            if (o === r.length) {
               const t = [...this.currentVariant.options];
               t[o - 1] = n, l.push(getVariantFromOptionArray(this.productData, t))
            } else l = i.filter((t => t.options[o - 1] === n && t.options[o - 2] === this.currentVariant["option" + (o - 1)]));
            if (l = l.filter(Boolean), l.length) {
               a.classList.remove(e), d && a.removeAttribute("disabled");
               const i = l.every((t => !t.available)) ? "add" : "remove";
               a.classList[i](t)
            } else a.classList.add(e), d && a.setAttribute("disabled", "true")
         }))
      }
      getVariantData() {
         if (!this.variantData) {
            const t = this.querySelector('#productVariants[type="application/json"]');
            if (t) try {
               this.variantData = JSON.parse(t.textContent)
            } catch (t) {}
         }
         return this.variantData || {}
      }
      getVariantGroupImageData() {
         if (!this.variantGroupImages) {
            const t = this.querySelector('#variantGroup[type="application/json"]');
            if (t) try {
               this.variantGroupImages = JSON.parse(t.textContent)
            } catch (t) {}
         }
         return this.variantGroupImages || {}
      }
      initOptionSwatches() {
         const {
            _colorSwatches: t = [],
            _imageSwatches: e = []
         } = window.MinimogSettings;
         
         // this.domNodes.optionNodes && this.domNodes.optionNodes.forEach((a => {
         //    const {
         //       optionType: i,
         //       optionPosition: r,
         //       value: s
         //    } = a.dataset, n = s && s.toLowerCase(), o = this.variantData.find((t => t[`option${r}`] === s)), d = o && o.featured_image && o.featured_image.src ? getSizedImageUrl(o.featured_image.src, "100x") : null, l = e.find((t => t.key === n)), c = t.find((t => t.key === n));
         //    if (d || l && l.value) {
         //       const t = a.querySelector("label");
         //       t && t.classList.add("has-bg-img")
         //    }
         //    const u = a.querySelector("label");
         //    if (u) switch (u.classList.remove("option-loading"), i) {
         //       case "default":
         //       case "image":
         //          u.style.backgroundImage = `url(${l&&l.value||d||""})`;
         //          break;
         //       case "color":
         //          u.style.backgroundColor = c && c.value || n, l && l.value && (u.style.backgroundImage = `url(${l.value})`)
         //    }
         // }))
      }
   }
   customElements.define("variant-picker", t)
}
if (!customElements.get("variant-button")) {
   class t extends HTMLElement {
      constructor() {
         super(), this.selectedSpan = this.querySelector(".option-label--selected"), this.addEventListener("change", this.updateSelectedValue)
      }
      updateSelectedValue() {
         this.value = Array.from(this.querySelectorAll("input")).find((t => t.checked)).value, this.setAttribute("data-selected-value", this.value), this.selectedSpan && (this.selectedSpan.textContent = this.value, this.selectedSpan.classList.remove("m:text-color-error"))
      }
   }
   if (customElements.define("variant-button", t), !customElements.get("variant-select")) {
      class e extends t {
         constructor() {
            super()
         }
         updateSelectedValue() {
            this.value = this.querySelector("select").value, this.setAttribute("data-selected-value", this.value), this.selectedSpan && (this.selectedSpan.textContent = this.value, this.selectedSpan.classList.remove("m:text-color-error"))
         }
      }
      customElements.define("variant-select", e)
   }
   if (!customElements.get("variant-image")) {
      class e extends t {
         constructor() {
            super()
         }
      }
      customElements.define("variant-image", e)
   }
   if (!customElements.get("variant-color")) {
      class e extends t {
         constructor() {
            super()
         }
      }
      customElements.define("variant-color", e)
   }
}